<template>
    <div v-click-outside="closeFilter" class="modelFilter">
        <router-link :class="{'modelFilter-compare': true, 'showLink': itemsLenght == 1}" 
        :to="{name: 'Comparator', params:{type: page, model: 'KAUAI'}}">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.8959 4.15098H0.828582C0.520005 4.15098 0.25 3.89991 0.25 3.57159C0.25 3.26257 0.500719 2.99219 0.828582 2.99219H10.8766C11.1852 2.99219 11.4552 3.24326 11.4552 3.57159C11.4552 3.8806 11.2045 4.15098 10.8959 4.15098Z" fill="currentColor"/>
                <path d="M3.58667 6.89377C3.43239 6.89377 3.29738 6.83583 3.18167 6.71995L0.423759 3.97746C0.211612 3.74571 0.211612 3.39807 0.423759 3.16631L3.16238 0.42382C3.39381 0.19206 3.74096 0.19206 3.9724 0.42382C4.20383 0.655579 4.20383 1.00322 3.9724 1.23498L1.63878 3.57189L3.99168 5.90879C4.20383 6.14055 4.20383 6.48819 3.99168 6.71995C3.87597 6.83583 3.72168 6.89377 3.58667 6.89377Z" fill="currentColor"/>
                <path d="M13.1725 11.0084H3.12448C2.8159 11.0084 2.5459 10.7573 2.5459 10.429C2.5459 10.12 2.79662 9.84961 3.12448 9.84961H13.1725C13.4811 9.84961 13.7511 10.1007 13.7511 10.429C13.7511 10.7573 13.5004 11.0084 13.1725 11.0084Z" fill="currentColor"/>
                <path d="M10.4331 13.7492C10.2788 13.7492 10.1438 13.6913 10.0281 13.5754C9.81592 13.3437 9.81592 12.996 10.0281 12.7643L12.381 10.4274L10.0281 8.09045C9.79663 7.85869 9.79663 7.51105 10.0281 7.27929C10.2595 7.04753 10.6066 7.04753 10.8381 7.27929L13.5767 10.0218C13.7889 10.2535 13.7889 10.6012 13.5767 10.8329L10.8381 13.5947C10.7224 13.6913 10.5874 13.7492 10.4331 13.7492Z" fill="currentColor"/>
            </svg>
            <span>Comparar {{ campareLabel }}</span>
        </router-link>
        <div class="modelFilter-filter">
            <p :class="{ 'active': showFilter }" @click="displayFilter($event)">
                <span>Filtrar</span> 
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z" fill="#1C1B1B"/>
                </svg>
            </p>

            <div v-show="showFilter" class="modelFilter-filter-options">
                <template v-for="(item,i) in fieldsArr">
                    <CheckBox v-if="item.vueComp" :key="i"
                    :isDisabled='item.disabled' :field='item.field' :fieldLabel='item.label' :isChecked="item.checked"
                    @checked-item="handleFilterChanges(i, item)" />
                    <p v-else :key="i"> {{ item.text }} </p>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    import CheckBox from '../../FormFields/CheckBox/CheckBox.vue'

    export default {
        name: 'FilterModel',
        components:{ CheckBox },
        props:{
            campareLabel:{type: String},
            itemsLenght:{type: Number},
            transmission: {type: [Array, Boolean], default: () => { return false }},
            priceRange: {type: [Object, Boolean], default: () => { return {}; }},
        },
        data(){return{
            showFilter: false,
            fieldsArr: [
                { vueComp: false, text: 'Transmissão' },
                // ...

                { vueComp: false, text: 'Preço Total' },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_price15', label: 'Menos de 15 000€', type: 2 },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_price25', label: 'Entre 15 000€ e 25 000€', type: 2 },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_price35', label: 'Entre 25 000€ e 35 000€', type: 2 },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_price35up', label: 'Mais de 35 000€', type: 2 },
                
                { vueComp: false, text: 'Prestação' },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_rent_200', label: 'Menos de 200€', type: 3 },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_rent_300', label: 'Entre 200€ e 400€', type: 3 },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_rent_400', label: 'Entre 300€ e 400€', type: 3 },
                { vueComp: true, checked: false, disabled: false, field: 'cfg_rent_400up', label: 'Mais de 400€', type: 3 },
            ],
            selectedTramss: [],
            selectedPrices: [],
            selectedRents: [],
        }},
        inject:['page'],
        mounted(){
            this.setTransmissions
        },
        watch: {
            priceRange: function(val){
                if(!val.minPrice) return
                
                let condArr = [
                    "(el.field == 'cfg_price15') && (val.minPrice >= 15000)",
                    "(el.field == 'cfg_price25') && ((val.minPrice >= 25000) || (val.maxPrice < 15000))",
                    "(el.field == 'cfg_price35') && ((val.minPrice >= 35000) || (val.maxPrice < 25000))",
                    "(el.field == 'cfg_price35up') && (val.maxPrice < 35000)",

                    "(el.field == 'cfg_rent_200') && (val.minRent >= 200)",
                    "(el.field == 'cfg_rent_300') && ((val.minRent >= 300) || (val.maxRent < 200))",
                    "(el.field == 'cfg_rent_400') && ((val.minRent >= 400) || (val.maxRent < 300))",
                    "(el.field == 'cfg_rent_400up') && (val.maxRent < 400)"
                ];

                this.fieldsArr.forEach(el => {
                    condArr.forEach(cond => {
                        if(eval(cond)){
                            el.disabled = true
                            if(el.checked){
                                el.checked = false
                                this.removeOptions(this.selectedPrices, el.field)
                                this.removeOptions(this.selectedRents, el.field)
                            }
                        }
                    })
                })
            }
        },
        computed: {
            setTransmissions(){
                let trm = this.transmission
                if(trm.length == 0) return false
                trm.forEach((el, index) => {
                    let obj = { vueComp: true, checked: false, disabled: false, field: el, label: el, type: 1}
                    this.fieldsArr.splice(index+1, 0, obj)
                }); return true
            }
        },
        methods: {
            displayFilter(){
                this.showFilter = !this.showFilter;
            },
            handleFilterChanges(i, item){
                this.fieldsArr[i].checked = !this.fieldsArr[i].checked

                 if(item.type == 1){
                    this.fieldsArr.forEach(el => el.disabled = false)
                    this.handleSelectedOptions(this.selectedTramss, item.field)
                    this.$emit('update:selectedTransmission', this.selectedTramss)
                }

                if(item.type == 2){
                    this.handleSelectedOptions(this.selectedPrices, item.field)
                    this.$emit('update:prices', this.selectedPrices)
                }

                if(item.type == 3){
                    this.handleSelectedOptions(this.selectedRents, item.field)
                    this.$emit('update:rents', this.selectedRents)
                }
            },
            handleSelectedOptions(arr, opt){
                let index = arr.indexOf(opt)
                index === -1 ? arr.push(opt) : arr.splice(index, 1)
            },
            removeOptions(arr, opt){
                let index = arr.indexOf(opt)
                if(index === -1) arr.splice(index, 1)
            },
            closeFilter(){
                if(this.showFilter){
                    this.showFilter = false
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import './FilterModel.scss';
</style>